import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../../hooks/useAuth";
import Navbar from "../Navbar/Navbar";
import "./BarberSettings.css";
import { FaCut } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";

export default function BarberSettings() {
  const { userSession } = useAuth();
  const barberId = userSession?.id;

  // Inicijalna stanja – ako nema podataka, vrijednosti su prazne

  const [serviceFormError, setServiceFormError] = useState(false);
  const [workShiftFormError, setWorkShiftFormError] = useState(false);
  const [vacationFormError, setVacationFormError] = useState(false);
  const [settingsFormError, setSettingsFormError] = useState(false);

  const [servicesList, setServicesList] = useState([]);
  const [workShiftsList, setWorkShiftsList] = useState([]);
  const [vacationsList, setVacationsList] = useState([]);
  const [settingsList, setSettingsList] = useState([]);

  const [service, setService] = useState({
    id: null,
    name: "",
    duration: "",
    price: "",
  });
  const [workShift, setWorkShift] = useState({
    id: null,
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
  });
  const [vacation, setVacation] = useState({
    id: null,
    startDate: "",
    endDate: "",
  });
  const [settings, setSettings] = useState({
    id: null,
    maxDaysInAdvance: "",
    maxAppointmentsPerDay: "",
  });

  useEffect(() => {
    if (!barberId) return;

    // Dohvati postojeće podatke za service (pretpostavljamo GET /service-by-barber/:id)
    axios
      .get(`/api/service-by-barber/${barberId}`)
      .then((res) => {
        if (res.data) {
          setServicesList(res.data);
        }
      })

      .catch((err) => console.error("Error fetching service:", err));

    // Dohvati work shift podatke
    axios
      .get(`/api/work-shift-by-barber/${barberId}`)
      .then((res) => {
        if (res.data) {
          setWorkShiftsList(res.data);
        }
      })

      .catch((err) => console.error("Error fetching work shift:", err));

    // Dohvati barber vacation podatke
    axios
      .get(`/api/barber-vacation-by-barber/${barberId}`)
      .then((res) => {
        if (res.data) {
          setVacationsList(res.data);
        }
      })
      .catch((err) => console.error("Error fetching vacation:", err));

    // Dohvati general settings podatke

    /* res.data.max_days_in_advance,
          res.data.max_appointments_per_day, */
    axios
      .get(`/api/barber-setting-by-barber/${barberId}`)
      .then((res) => {
        if (res.data) {
          setSettingsList(res.data);
        }
      })

      .catch((err) => console.error("Error fetching settings:", err));
  }, [barberId]);

  const isFormValid = (formDataObj) => {
    return Object.values(formDataObj).every((value) => value.trim() !== "");
  };

  const deleteItem = (endpoint, id, setState) => {
    axios
      .delete(`/api/${endpoint}/${id}`)
      .then(() => {
        setState((prev) => prev.filter((item) => item.id !== id));
      })
      .catch((err) => console.error(`Error deleting ${endpoint}:`, err));
  };

  // HANDLERS ZA SERVICE FORMU
  const handleServiceChange = (e) => {
    const { name, value } = e.target;
    setService((prev) => ({ ...prev, [name]: value }));
  };

  const handleServiceSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const values = Object.fromEntries(formData.entries());

    if (!isFormValid(values)) {
      setServiceFormError(true);
      return;
    }

    setServiceFormError(false);
    if (service.id) {
      axios
        .put(`/api/service/${service.id}`, { ...service, barberId })
        .then((res) => {
          alert("Service updated successfully!");
          //setService(res.data);
          setServicesList((prev) => [...prev, res.data]); // Dodaj novu uslugu u listu
          setService({ name: "", duration: "", price: "" }); // Resetiraj formu
        })
        .catch((err) => console.error("Error updating service:", err));
    } else {
      axios
        .post(`/api/service`, { ...service, barberId })
        .then(() => {
          return axios.get(`/api/service-by-barber/${barberId}`); // Dohvati ažuriranu listu
        })
        .then((res) => {
          alert("Service created successfully!");
          //setService(res.data);
          setServicesList(res.data); // Dodaj novu uslugu u listu
          setService({ name: "", duration: "", price: "" }); // Resetiraj formu
        })
        .catch((err) => console.error("Error creating service:", err));
    }
  };

  // HANDLERS ZA WORK SHIFT FORMU
  const handleWorkShiftChange = (e) => {
    const { name, value } = e.target;
    setWorkShift((prev) => ({ ...prev, [name]: value }));
  };

  const handleWorkShiftSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const values = Object.fromEntries(formData.entries());

    if (!isFormValid(values)) {
      setWorkShiftFormError(true);
      return;
    }
    setWorkShiftFormError(false);
    if (workShift.id) {
      axios
        .put(`/api/work-shift/${workShift.id}`, { ...workShift, barberId })
        .then(() => {
          return axios.get(`/api/work-shift-by-barber/${barberId}`);
        })
        .then((res) => {
          alert("Work shift updated successfully!");
          setWorkShiftsList(res.data);
          setWorkShift({
            startDate: "",
            endDate: "",
            startTime: "",
            endTime: "",
          });
        })
        .catch((err) => console.error("Error updating work shift:", err));
    } else {
      axios
        .post(`/api/work-shift`, { ...workShift, barberId })
        .then(() => {
          return axios.get(`/api/work-shift-by-barber/${barberId}`);
        })
        .then((res) => {
          alert("Work shift created successfully!");
          setWorkShiftsList(res.data);
          setWorkShift({
            startDate: "",
            endDate: "",
            startTime: "",
            endTime: "",
          });
        })
        .catch((err) => console.error("Error creating work shift:", err));
    }
  };

  // HANDLERS ZA VACATION FORMU
  const handleVacationChange = (e) => {
    const { name, value } = e.target;
    setVacation((prev) => ({ ...prev, [name]: value }));
  };

  const handleVacationSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const values = Object.fromEntries(formData.entries());

    if (!isFormValid(values)) {
      setVacationFormError(true);
      return;
    }
    setVacationFormError(false);
    if (vacation.id) {
      axios
        .put(`/api/barber-vacation/${vacation.id}`, { ...vacation, barberId })
        .then(() => {
          return axios.get(`/api/barber-vacation-by-barber/${barberId}`);
        })
        .then((res) => {
          alert("Vacation updated successfully!");
          setVacationsList(res.data);
          setVacation({ startDate: "", endDate: "" });
        })
        .catch((err) => console.error("Error updating vacation:", err));
    } else {
      axios
        .post(`/api/barber-vacation`, { ...vacation, barberId })
        .then(() => {
          return axios.get(`/api/barber-vacation-by-barber/${barberId}`);
        })
        .then((res) => {
          setVacationsList(res.data);
          setVacation({ startDate: "", endDate: "" });
        })
        .catch((err) => console.error("Error creating vacation:", err));
    }
  };

  // HANDLERS ZA SETTINGS FORMU
  const handleSettingsChange = (e) => {
    const { name, value } = e.target;
    setSettings((prev) => ({ ...prev, [name]: value }));
  };

  const handleSettingsSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const values = Object.fromEntries(formData.entries());

    if (!isFormValid(values)) {
      setSettingsFormError(true);
      return;
    }
    setSettingsFormError(false);

    if (settings.id) {
      axios
        .put(`/api/barber-setting/${settings.id}`, { ...settings, barberId })
        .then(() => {
          return axios.get(`/api/barber-setting-by-barber/${barberId}`);
        })
        .then((res) => {
          alert("Settings updated successfully!");
          setSettingsList(res.data);
          setSettings({ maxDaysInAdvance: "", maxAppointmentsPerDay: "" });
        })
        .catch((err) => console.error("Error updating settings:", err));
    } else {
      axios
        .post(`/api/barber-setting`, { ...settings, barberId })
        .then(() => {
          return axios.get(`/api/barber-setting-by-barber/${barberId}`);
        })
        .then((res) => {
          alert("Settings created successfully!");
          setSettingsList(res.data);
          setSettings({ maxDaysInAdvance: "", maxAppointmentsPerDay: "" });
        })
        .catch((err) => console.error("Error creating settings:", err));
    }
  };
  //Napisat
  return (
    <div className="barber-settings">
      <Navbar
        className="navbar"
        leftIcon={FaCut}
        leftLink="/barber-home"
        rightIcon={FiLogOut}
        isLogout
      />
      <h2>Barber Settings</h2>

      <section className="form-section">
        <h3>Service</h3>
        <ul>
          {servicesList.map((servicesList) => (
            <li key={servicesList.id} className="item">
              <div className="row">
                <span>
                  {servicesList.name} – {servicesList.duration} min – $
                  {servicesList.price}
                </span>
                <button
                  onClick={() =>
                    deleteItem("service", servicesList.id, setServicesList)
                  }
                >
                  Delete
                </button>
              </div>
            </li>
          ))}
        </ul>

        <form onSubmit={handleServiceSubmit}>
          <label>
            Name:
            <input
              type="text"
              name="name"
              value={service.name || ""}
              onChange={handleServiceChange}
            />
          </label>
          <label>
            Duration:
            <input
              type="text"
              name="duration"
              value={service.duration || ""}
              onChange={handleServiceChange}
            />
          </label>
          <label>
            Price:
            <input
              type="text"
              name="price"
              value={service.price || ""}
              onChange={handleServiceChange}
            />
          </label>
          {serviceFormError && (
            <p className="form-error">Sva polja moraju biti popunjena!</p>
          )}
          <button type="submit">Save Service</button>
        </form>
      </section>

      <section className="form-section">
        <h3>Work Shift</h3>

        <ul>
          {workShiftsList.map((workShiftsList) => (
            <li key={workShiftsList.id} className="item">
              <div className="row">
                <span>
                  Start date:{" "}
                  {new Date(workShiftsList.start_date).toLocaleDateString()} |
                  End date:{" "}
                  {new Date(workShiftsList.end_date).toLocaleDateString()} |
                  Start time: {workShiftsList.start_time} | End time:{" "}
                  {workShiftsList.end_time}
                </span>
                <button
                  onClick={() =>
                    deleteItem(
                      "work-shift",
                      workShiftsList.id,
                      setWorkShiftsList
                    )
                  }
                >
                  Delete
                </button>
              </div>
            </li>
          ))}
        </ul>

        <form onSubmit={handleWorkShiftSubmit}>
          <label>
            Start Date:
            <input
              type="date"
              name="startDate"
              value={workShift.startDate}
              onChange={handleWorkShiftChange}
            />
          </label>
          <label>
            End Date:
            <input
              type="date"
              name="endDate"
              value={workShift.endDate}
              onChange={handleWorkShiftChange}
            />
          </label>
          <label>
            Start Time:
            <input
              type="time"
              name="startTime"
              value={workShift.startTime}
              onChange={handleWorkShiftChange}
            />
          </label>
          <label>
            End Time:
            <input
              type="time"
              name="endTime"
              value={workShift.endTime}
              onChange={handleWorkShiftChange}
            />
          </label>
          {workShiftFormError && (
            <p className="form-error">Sva polja moraju biti popunjena!</p>
          )}

          <button type="submit">Save Work Shift</button>
        </form>
      </section>

      <section className="form-section">
        <h3>Barber Vacation</h3>

        <ul>
          {vacationsList.map((vacationsList) => (
            <li key={vacationsList.id} className="item">
              <div className="row">
                <span>
                  Start date:{" "}
                  {new Date(vacationsList.start_date).toLocaleDateString()} End
                  date: {new Date(vacationsList.end_date).toLocaleDateString()}
                </span>
                <button
                  onClick={() =>
                    deleteItem(
                      "barber-vacation",
                      vacationsList.id,
                      setVacationsList
                    )
                  }
                >
                  Delete
                </button>
              </div>
            </li>
          ))}
        </ul>

        <form onSubmit={handleVacationSubmit}>
          <label>
            Start Date:
            <input
              type="date"
              name="startDate"
              value={vacation.startDate}
              onChange={handleVacationChange}
            />
          </label>
          <label>
            End Date:
            <input
              type="date"
              name="endDate"
              value={vacation.endDate}
              onChange={handleVacationChange}
            />
          </label>
          {vacationFormError && (
            <p className="form-error">Sva polja moraju biti popunjena!</p>
          )}
          <button type="submit">Save Vacation</button>
        </form>
      </section>

      <section className="form-section">
        <h3>Settings</h3>

        <ul>
          {settingsList.map((settingsList) => (
            <li key={settingsList.id} className="item">
              <div className="row">
                <span>
                  Max days in advance: {settingsList.max_days_in_advance} – Max
                  appointments per day: {settingsList.max_appointments_per_day}
                </span>
                <button
                  onClick={() =>
                    deleteItem(
                      "barber-setting",
                      settingsList.id,
                      setSettingsList
                    )
                  }
                >
                  Delete
                </button>
              </div>
            </li>
          ))}
        </ul>

        <form onSubmit={handleSettingsSubmit}>
          <label>
            Max Days In Advance:
            <input
              type="number"
              name="maxDaysInAdvance"
              value={settings.maxDaysInAdvance}
              onChange={handleSettingsChange}
            />
          </label>
          <label>
            Max Appointments:
            <input
              type="number"
              name="maxAppointmentsPerDay"
              value={settings.maxAppointmentsPerDay}
              onChange={handleSettingsChange}
            />
          </label>
          {settingsFormError && (
            <p className="form-error">Sva polja moraju biti popunjena!</p>
          )}
          <button type="submit">Save Settings</button>
        </form>
      </section>
    </div>
  );
}
